import { programsApi } from './api.js'

interface PartSource { id: string; durationSec: number }
interface ProgramSource extends PartSource { parts?: PartSource[]; interPartBreakSec?: number }

/** Removal is its own save: no editorial/media/duration edits can hitch a ride. */
export async function removeCatalogPart(
  program: ProgramSource,
  partId: string,
  confirm: (message: string) => boolean,
) {
  if (!program.parts?.some(part => part.id === partId)) throw new Error('Partie introuvable')
  const data = {
    parts: [program, ...program.parts].filter(part => part.id !== partId)
      .map(({ id, durationSec }) => ({ id, durationSec })),
    interPartBreakSec: program.interPartBreakSec ?? 0,
  }
  const preview = await programsApi.previewPartsRemoval(program.id, data)
  const date = new Intl.DateTimeFormat('fr-FR', {
    timeZone: 'Europe/Paris', dateStyle: 'short', timeStyle: 'medium',
  })
  const details = preview.airings.map(item =>
    `${date.format(new Date(item.startTime))} → ${date.format(new Date(item.endTime))} — ${item.title} (${item.gridName})`,
  ).join('\n')
  if (!confirm(
    `Retirer cette partie du catalogue ?\n\n`
    + `${preview.airings.length} passage(s) futur(s) en attente seront supprimés :\n`
    + (details || 'Aucun passage futur concerné.')
    + '\n\nLes créneaux resteront vides, sans décalage ni comblage. Les publicités, jingles, directs et autres programmes restent à leur place.'
    + `\n${preview.retainedAirings} passage(s) conservé(s) ; l’historique et les fichiers médias sont préservés.`
    + '\n\nConfirmer le retrait maintenant ?',
  )) return null
  return programsApi.updateParts(program.id, { ...data, removalPreviewToken: preview.token })
}
